document.querySelectorAll('[data-deal-end]').forEach((timer) => {
  if (timer.dataset.dealTimerReady === 'true') return;
  timer.dataset.dealTimerReady = 'true';
  const end = Date.parse(timer.dataset.dealEnd);
  if (!Number.isFinite(end)) return;
  const mode = timer.dataset.dealMode || 'days';
  const dayUnit = timer.querySelector('[data-deal-days-unit]');
  const daysNode = timer.querySelector('[data-deal-days]');
  const hoursNode = timer.querySelector('[data-deal-hours]');
  const minutesNode = timer.querySelector('[data-deal-minutes]');
  const secondsNode = timer.querySelector('[data-deal-seconds]');
  const activeLabel = timer.querySelector('[data-deal-active-label]');
  const activeUnits = timer.querySelector('[data-deal-active-units]');
  const expiredMessage = timer.querySelector('[data-deal-expired]');
  const dayInMilliseconds = 24 * 60 * 60 * 1000;
  const write = (node, value) => {
    if (node) node.textContent = String(value).padStart(2, '0');
  };
  const showExpiredState = () => {
    if (!expiredMessage) {
      timer.hidden = true;
      return;
    }
    if (activeLabel) activeLabel.hidden = true;
    if (activeUnits) activeUnits.hidden = true;
    expiredMessage.hidden = false;
    timer.hidden = false;
  };
  const tick = () => {
    const remaining = end - Date.now();
    if (remaining <= 0) {
      showExpiredState();
      return false;
    }
    const totalSeconds = Math.floor(remaining / 1000);
    if (mode === 'adaptive') {
      const showDays = remaining >= dayInMilliseconds;
      if (dayUnit) dayUnit.hidden = !showDays;
      write(daysNode, Math.floor(totalSeconds / 86400));
      write(hoursNode, showDays ? Math.floor((totalSeconds % 86400) / 3600) : Math.floor(totalSeconds / 3600));
      write(minutesNode, Math.floor((totalSeconds % 3600) / 60));
      write(secondsNode, totalSeconds % 60);
    } else if (mode === 'hours') {
      write(hoursNode, Math.floor(totalSeconds / 3600));
      write(minutesNode, Math.floor((totalSeconds % 3600) / 60));
      write(secondsNode, totalSeconds % 60);
    } else {
      const totalMinutes = Math.floor(totalSeconds / 60);
      write(daysNode, Math.floor(totalMinutes / 1440));
      write(hoursNode, Math.floor((totalMinutes % 1440) / 60));
      write(minutesNode, totalMinutes % 60);
    }
    if (activeLabel) activeLabel.hidden = false;
    if (activeUnits) activeUnits.hidden = false;
    if (expiredMessage) expiredMessage.hidden = true;
    timer.hidden = false;
    return true;
  };
  if (tick()) {
    const interval = setInterval(() => { if (!tick()) clearInterval(interval); }, ['hours', 'adaptive'].includes(mode) ? 1000 : 30000);
  }
});
